package presentation.screens.common.account

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowRight
import androidx.compose.material.icons.filled.Logout
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import common.asset.ImageAsset
import component.address.AddressRow
import component.image.CircularImageView
import component.image.FriendlyIcon
import component.loader.AppLoader
import component.navigation.TopNavBar
import component.profile.MobileNumberRow
import component.profile.ProfileRow
import feature.alert.handler.AlertHandler
import feature.auth.model.FriendlyUser
import feature.auth.viewModel.AuthViewModel
import feature.customer.viewModel.CustomerViewModel
import presentation.screens.common.account.component.LanguageRow
import presentation.screens.common.address_screen.list.AddressListScreen
import presentation.screens.common.auth.LoginScreen
import theme.ThemeColor

class AccountScreen : Screen {
    @Composable
    override fun Content() {
        val viewModel = AuthViewModel()
        val selectedLanguage = viewModel.selectedLanguage.collectAsState()
        val customerViewModel = CustomerViewModel()
        val isLoggedIn = viewModel.isLoggedIn.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.checkIfLoggedIn()
        }
        val navigator = LocalNavigator.current
        if (isLoggedIn.value) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
            ) {
                TopNavBar("Account")
                LazyColumn(
                    modifier = Modifier
                        .fillMaxSize()
                ) {
                    item {
                        AppLoader(viewModel)
                        CircularImageView(id = FriendlyUser().id, true)
                    }
                    item {
//                        Spacer(modifier = Modifier.height(15.dp))
//                MembershipRow(authViewModel = viewModel, customerViewModel)
                        Spacer(modifier = Modifier.height(15.dp))
                        ProfileRow(viewModel)
                        Spacer(modifier = Modifier.height(15.dp))
                        MobileNumberRow(viewModel)
                        Spacer(modifier = Modifier.height(15.dp))
                        AddressRow(onClick = { navigator?.push(AddressListScreen()) })
                        Spacer(modifier = Modifier.height(15.dp))
                        LanguageRow(selectedLanguage.value)
                        Spacer(modifier = Modifier.height(15.dp))
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(60.dp)
                                .padding(start = 8.dp, end = 8.dp)
                                .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                                .clip(RoundedCornerShape(10.dp))
                                .clickable {
                                    viewModel.logout()
                                    AlertHandler.shared().showAlert("Success", "Logged Out")
                                }
                                .padding(5.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(
                                Icons.Default.Logout,
                                contentDescription = "Home",
                                modifier = Modifier.weight(0.05f),
                                tint = ThemeColor.shared().iconTint
                            )
                            Text("Logout", modifier = Modifier.weight(0.2f))
                            Icon(
                                Icons.Filled.ArrowRight,
                                "Language",
                                modifier = Modifier.weight(0.03f),
                                tint = ThemeColor.shared().iconTint
                            )
                        }
                    }
                }
            }

        } else {
            Column {
                TopNavBar(title = "Account")
                Row(
                    modifier = Modifier
                        .height(80.dp)
                        .padding(start = 8.dp, end = 8.dp, top = 8.dp)
                        .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                        .clip(RoundedCornerShape(10.dp))
                        .clickable {
                            navigator?.push(LoginScreen())
                        }
                        .padding(5.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FriendlyIcon(name = ImageAsset.logoutIcon, size = 30)
                    Text("Login/Register", modifier = Modifier.weight(0.2f))
                    Icon(
                        Icons.Filled.ArrowRight, "Language", modifier = Modifier.weight(0.03f),
                        tint = ThemeColor.shared().iconTint
                    )
                }
            }

        }
    }
}

